module.exports = __webpack_public_path__ + "src/assets/share/cancel.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/cancel.svg
// module id = 4
// module chunks = 0